import {
  SearchLayout,
  type IHeaderTheme,
} from "@/api/AppApi/services/company/interfaces/ICompany";
import type { ICategory } from "@/api/AppApi/services/home/interfaces/ICategory";
import { PagesPaths } from "@/utils/functions/pages-paths";

export interface ISearchCategoryOption {
  slug: string;
  name: string;
}

// Anything other than an explicit "advanced" (missing field from an old cached
// company response, unknown value) keeps the original button layout.
export const isAdvancedSearchLayout = (
  header?: Pick<IHeaderTheme, "search_layout"> | null,
) => header?.search_layout === SearchLayout.advanced;

// Only what the <select> renders crosses the server → client boundary.
export const toSearchCategoryOptions = (
  categories?: ICategory[] | null,
): ISearchCategoryOption[] =>
  (categories ?? [])
    .filter((category) => category?.slug && category?.name)
    .map(({ slug, name }) => ({ slug, name }));

// Slug (not id) matches what the category page sends as `category_id`.
// No category = "All categories", so the param is omitted entirely.
export const buildSearchHref = (q: string, categorySlug?: string | null) => {
  const params = new URLSearchParams({ q: q.trim() });
  if (categorySlug) params.set("category_id", categorySlug);
  return `${PagesPaths.search}?${params.toString()}`;
};
